import { render, staticRenderFns } from "./PlacesToGo.vue?vue&type=template&id=de880cb6&scoped=true&"
import script from "./PlacesToGo.vue?vue&type=script&lang=js&"
export * from "./PlacesToGo.vue?vue&type=script&lang=js&"
import style0 from "./PlacesToGo.vue?vue&type=style&index=0&id=de880cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de880cb6",
  null
  
)

export default component.exports